import React from 'react';
import countries from './country';
import Select from "react-select";
import Utility from "../utility";

class Form extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sendingEnquiry:false
        }
    }

    enquirySubmit(e) {
        e.preventDefault();
        let d = Utility.objectCopy(this.state);
        delete d['sendingEnquiry'];
        this.props.save(d, "form",false); //array false
        this.setState({sendingEnquiry:true})
        this.props.finalSubmit();
    }

    getFormValues(e, type = "", val = "") {
        let element = e.target;
        val = val ? val : element.value;

        type = type ? type : element.getAttribute('name');
        if (type) {
            this.setState({[type]: val});
        }
    }

    render() {
        return (
            <form onSubmit={e=>this.enquirySubmit(e)}>
                <div className="row">
                    <div className="col-12">
                        <div className="form-group">
                            <label htmlFor="notes">Besondere Anmerkungen</label>
                            <input id="notes" name="notes" className="form-control"
                                   onChange={e => this.getFormValues(e)}
                                   placeholder="z.B.: besondere Stückzahl etc."/>
                        </div>
                    </div>

                    <div className="col-12 col-lg-6">
                        <div className="form-group">
                            <label htmlFor="fname">Vorname<span className="required">*</span></label>
                            <input id="fname" name="fname" className="form-control" onChange={e => this.getFormValues(e)} required/>
                        </div>
                    </div>

                    <div className="col-12 col-lg-6">
                        <div className="form-group">
                            <label htmlFor="lname">Nachname<span className="required">*</span></label>
                            <input id="lname" name="lname" className="form-control" onChange={e => this.getFormValues(e)} required/>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 col-lg-6">
                        <div className="form-group">
                            <label htmlFor="firma">Firma</label>
                            <input id="firma" name="firma" className="form-control" onChange={e => this.getFormValues(e)} />
                        </div>
                    </div>

                    <div className="col-12 col-lg-6">
                        <div className="form-group">
                            <label htmlFor="address">Adresse</label>
                            <input id="address" name="address" className="form-control" onChange={e => this.getFormValues(e)} />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 col-lg-6">
                        <div className="form-group">
                            <label htmlFor="Stadt">Stadt</label>
                            <input id="Stadt" name="Stadt" className="form-control" onChange={e => this.getFormValues(e)} />
                        </div>
                    </div>

                    <div className="col-12 col-lg-6">
                        <div className="form-group">
                            <label htmlFor="plz">PLZ</label>
                            <input id="plz" name="plz" className="form-control" onChange={e => this.getFormValues(e)} />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <div className="form-group">
                            <label htmlFor="country">Land</label>
                            <Select options={countries} id="country" onChange={(e,a)=>this.getFormValues({},"country",e.label)} />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 col-lg-6">
                        <div className="form-group">
                            <label htmlFor="email">Ihre Mail Adresse<span className="required">*</span></label>
                            <input id="email" name="email" type="email" className="form-control" onChange={e => this.getFormValues(e)} required/>
                        </div>
                    </div>

                    <div className="col-12 col-lg-6">
                        <div className="form-group">
                            <label htmlFor="phone">Ihre Tel.Nr.</label>
                            <input id="phone" name="phone" type="tel" className="form-control" onChange={e => this.getFormValues(e)} />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <div className="form-group">
                            <input id="terms" name="terms" type="checkbox" required/>
                            <label htmlFor="terms" style={{paddingLeft: 10}}> Wir senden Ihnen gerne unsere Prospekte
                                zu! Beachten Sie unsere <span className="required">*</span> <a target="_blank"
                                    href="/terms">Datenschutzerklärung.</a></label>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <div className="text-right">
                            <button className="btn-style-two button button--primary" disabled={this.state.sendingEnquiry ? "disabled" : ""}>{this.state.sendingEnquiry ? "Anfrage senden..." : "Nachricht senden"}</button>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default Form;
